import {
  GenericDateIsoStringInputComponent,
  GenericDisabledTextInputComponent,
  GenericFreeTextInputComponent,
  GenericNumericInputComponent,
  GenericPercentageInputComponent,
} from "./InputComponents";

export const branchDefinition = {
  id: {
    displayName: "ID",
    displayValue: (entity) => String(entity.id),
    inputComponent: GenericDisabledTextInputComponent,
    isValid: (entity) => true,
  },
  branchName: {
    displayName: "Branch Name",
    displayValue: (entity) => entity.branchName,
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => entity.branchName !== "",
  },
  shortCode: {
    displayName: "Short Code",
    displayValue: (entity) => entity.shortCode,
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => entity.shortCode !== "",
  },
  lclLinehaulCostCentre: {
    displayName: "LCL CC",
    displayValue: (entity) => String(entity.lclLinehaulCostCentre),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) => /\d+/.test(String(entity.lclLinehaulCostCentre)),
  },
  parcelCostCentre: {
    displayName: "Parcel CC",
    displayValue: (entity) => String(entity.parcelCostCentre),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) => /\d+/.test(String(entity.parcelCostCentre)),
  },
  faf: {
    displayName: "FAF",
    displayValue: (entity) => `${parseFloat((entity.faf * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) => {
      console.log(entity.faf);
      if (entity.faf === 1) {
        return true;
      }
      return /^0(\.\d{1,4})?$/.test(String(entity.faf));
    },
  },
  linehaulFAF: {
    displayName: "Linehaul FAF",
    displayValue: (entity) =>
      `${parseFloat((entity.linehaulFAF * 100).toFixed(2))}%`,
    inputComponent: GenericPercentageInputComponent,
    isValid: (entity) => {
      if (entity.linehaulFAF === 1) {
        return true;
      }
      return /^0(\.\d{1,4})?$/.test(String(entity.linehaulFAF));
    },
  },
  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
  endDate: {
    displayName: "End",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
};

export const columns = [
  "id",
  "branchName",
  "shortCode",
  "lclLinehaulCostCentre",
  "parcelCostCentre",
  "faf",
  "linehaulFAF",
  "startDate",
  "endDate",
];

export const defaultBranch = {
  id: 0,
  branchName: "",
  shortCode: "",
  lclLinehaulCostCentre: undefined,
  parcelCostCentre: undefined,
  faf: undefined,
  linehaulFAF: undefined,
  startDate: undefined,
  endDate: undefined,
};
